import "./widgets-core6.css";
import { defineComponent as p, useCssVars as _, unref as i, computed as f, openBlock as t, createElementBlock as n, normalizeClass as G, Fragment as v, renderList as g, createElementVNode as s, renderSlot as d, createTextVNode as z, toDisplayString as S } from "vue";
import { _ as $ } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const h = { class: "recordGrid__item__name" }, w = { class: "recordGrid__item__value" }, x = /* @__PURE__ */ p({
  __name: "RecordGrid",
  props: {
    items: {},
    direction: { default: "column" },
    responsive: { type: Boolean, default: !0 },
    fontSize: { default: "small" }
  },
  setup(c) {
    _((r) => ({
      38704221: r.direction,
      "36b2eaf8": u.value,
      d846e964: i(a),
      "40576db2": i(l)
    }));
    const e = c, a = e.direction === "row" ? "column" : "row", l = e.direction === "row" ? "center" : "end", u = f(() => e.direction === "row" ? "16px" : e.fontSize === "large" ? "8px" : "2.5px");
    return (r, k) => (t(), n("ul", {
      class: G([
        "recordGrid",
        `recordGrid--${e.direction}`,
        `recordGrid--${e.items.length}items`,
        `recordGrid--${e.fontSize}-fontsize`,
        { "recordGrid--responsive": e.responsive }
      ])
    }, [
      (t(!0), n(v, null, g(r.items, (o, m) => (t(), n("li", {
        class: "recordGrid__item",
        key: m
      }, [
        s("span", h, [
          d(r.$slots, "name", { item: o }, () => [
            z(S(o.name), 1)
          ], !0)
        ]),
        s("span", w, [
          d(r.$slots, "value", { item: o }, void 0, !0)
        ])
      ]))), 128))
    ], 2));
  }
}), V = /* @__PURE__ */ $(x, [["__scopeId", "data-v-ca152712"]]);
export {
  V as default
};
//# sourceMappingURL=widgets-core.es8.js.map
